import { copyAllProperties } from "./utils";
import BaseObject from "./BaseObject";
import ConnectableObject from "./ConnectableObject";
import type Page from "./Page";
import BaseModel, { executePaste_Parameters } from "./BaseModel";

import Logger from "../Logger";
const logger = new Logger();

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import Room from "./Room";
ObjectFactory.registerClass("Memo", (data?: any, parent?: BaseModel) => {
  return new Memo(data, parent);
});
//////////////////////////////////////////////////

export default class Memo extends ConnectableObject {
  public get className(): string {
    return "Memo"; // no itx
  }

  getParentCollectionName(): string | undefined {
    return "memos"; // no itx
  }

  constructor(data?: any, parent?: BaseModel) {
    super(data, parent);
    copyAllProperties(data, this);
  }

  /////////////////////////////////////////////////////////////////////////

  onSelect(newValue: boolean) {}
  get maxNameCharacters(): number {
    return 100000000000000000;
  }

  // -----------------------------------------------------------------------------
  // fontSize
  // -----------------------------------------------------------------------------
  _fontSize: number | undefined = undefined;
  get fontSize(): number {
    return this._fontSize || 16;
  }
  set fontSize(newValue: number) {
    this.beforeChange("fontSize");
    this._fontSize = newValue;

    this.changed("fontSize");
  }

  // -----------------------------------------------------------------------------
  // isRoomTag
  // -----------------------------------------------------------------------------
  _isRoomTag: boolean = false;
  get isRoomTag(): boolean {
    return this._isRoomTag;
  }

  set isRoomTag(newValue: boolean) {
    if (this._isRoomTag === newValue) return;
    this.beforeChange("isRoomTag");
    this._isRoomTag = newValue;
    this.changed("isRoomTag");
  }

  // -----------------------------------------------------------------------------

  getPersistentProperties(): string[] {
    return ["isRoomTag", "_fontSize", ...super.getPersistentProperties()]; // no itx
  }

  delete(): Array<BaseObject> {
    this.isDeleting = true;

    var res = new Array<BaseObject>();

    res = res.concat(super.delete());
    return res;
  }

  ////////////////////////////////////////////////////////////////////
  canBeEditedInteractive(): boolean {
    return false;
  }

  //////////////////////////////////////////////////////
  ///////////// for copy
  getExtendedCopyCollection(startItem: BaseModel): Array<BaseModel> {
    const res = new Array<BaseModel>();
    res.push(startItem);

    return res;
  }
  // //////////////////////////////////////////////////////
  // ///////////// for paste
  async pasteItem(params: { item: BaseModel; allItems: Array<BaseModel> }): Promise<Array<BaseModel>> {
    return (await this.parent?.pasteItem(params)) || [];
  }

  async executePaste(params: executePaste_Parameters): Promise<Array<BaseModel>> {
    const { parent, isCopyRootObj } = params;

    const page = parent as Page;
    var undoObjects: Array<BaseModel> = [this];

    if (page) {
      if (isCopyRootObj) {
        page.addMemo(this);
        super.updatePageUsageAfterCopy();
      }
    }
    return undoObjects;
  }

  get parentRoom(): Room | undefined {
    return (this.parent as Page).parentRoom;
  }

  get selected(): boolean {
    if (this.isRoomTag) {
      return this.parentRoom?.selected || false;
    } else {
      return this._selected;
    }
  }

  set selected(newValue: boolean) {
    if (this.isRoomTag) {
      this.parentRoom?.setSelected(newValue);
    } else {
      this.setSelected(newValue);
    }
  }

  // //////////////////////////////////////////////////////
  // ///////////// for paste
  mapAfterCopy() {
    if (!this.mapAfterCopyDone) {
      super.mapAfterCopy();
    }
  }
}
